import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Pencil } from 'lucide-react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const CustomFieldTextRenderer = ({ value, data, ...props }) => {
  const { colors } = useTheme();
  const isPublic = data?.options?.type === 'public';

  if (data?.options?.showLoader) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={160}
        viewBox="0 0 400 160"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="20" y="16" rx="3" ry="3" width="80" height="8" />
      </ContentLoader>
    );
  }

  return (
    <Flex
      sx={{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        px: '8px',
        cursor: isPublic ? 'default' : 'pointer',
        '&:hover .edit-icon, .ag-cell-focus & .edit-icon': {
          opacity: isPublic ? 0 : 1,
        },
      }}
      {...props}
    >
      <Text
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: 'text.main',
          flexGrow: 1,
        }}
      >
        {value}
      </Text>
      {!isPublic && (
        <Flex
          className="edit-icon"
          alignItems="center"
          flex="0 0 auto"
          sx={{
            color: 'text.subtle',
            opacity: 0,
            transition: 'opacity 0.2s ease-in-out',
          }}
        >
          <Box as={Pencil} width="16px" height="16px" aria-hidden="true" />
        </Flex>
      )}
    </Flex>
  );
};

CustomFieldTextRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.object,
};

CustomFieldTextRenderer.defaultProps = {
  value: '',
  data: {},
};
